import { useState } from "react";
import axiosService from "../../../../core/services/axios-service";
import { ApiRoutes } from "../../../../core/dictionary/api-url";
import ToastService from "../../../../core/services/toaster-service";

export default function AddBusinessAdminUser({ organizationId, onSuccess }) {
  const [form, setForm] = useState({
    fullName: null,
    email: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    if (organizationId) {
      form.organizationId = organizationId;
    } else {
      setError("Organization ID is required.");
      setLoading(false);
      return;
    }
    try {
      let res = await axiosService.post(
        ApiRoutes.ADD_BUSINESS_ADMIN_USER,
        form
      );
      if (res.data && res.data.success) {
        if (onSuccess) {
          ToastService.success("Business Admin User created successfully.");
          onSuccess(res.data);
        }
      } else {
        setError(res.data.message || "Failed to create Business Admin User.");
      }
    } catch (err) {
      setError("Server error. Please try again.");
    }
    setLoading(false);
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="p-3">
        <div className="mb-3">
          <label className="form-label">Admin Full Name</label>
          <input
            type="text"
            name="fullName"
            className="form-control"
            placeholder="Enter admin full name"
            value={form.fullName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="Enter admin email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        {error && <div className="text-danger mb-2">{error}</div>}
        <button type="submit" className="btn btn-gradient" disabled={loading}>
          {loading ? "Loading..." : "Create Business Admin User"}
        </button>
      </form>
    </>
  );
}
